// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:21:54

export default {
  "id": "merge-heroes",
  "slug": "merge-heroes",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9ec75b0c2e184d00ad68f9de4a5d0496-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9ec75b0c2e184d00ad68f9de4a5d0496/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Merge Heroes",
      "description": "In this game, you will command squads of melee fighters and ranged archers fighting against waves of enemies. Your agility and strategic thinking will give you an edge to victory.\n\nUnlock new powerful fighters and accurate archers by combining those available for purchase. Place them on the map according to abilities and win.\n\nYou will have to discover not only new characters, but also beautiful different worlds, enjoy our new game.\n\nTranslated with DeepL.com (free version)",
      "instructions": "Merge same characters by dragging one on top of another to get more powerful ones. Unlock new characters and expand your army",
      "genres": [
        "Casual",
        "Strategy"
      ],
      "tags": [
        "1player",
        "army",
        "enemies",
        "fighting",
        "singleplayer"
      ]
    },
    "zh-CN": {
      "title": "合并英雄",
      "description": "在这款游戏中，你将指挥近战小队和远程弓箭手，对抗一波又一波的敌人。你的敏捷性和战略思维将为你赢得胜利的优势。\n\n通过组合可购买的战士和弓箭手，解锁新的强大战士和精准弓箭手。根据他们的能力在地图上放置他们，赢得胜利。\n\n你将不仅会发现新角色，还会探索美丽而不同的世界，享受我们的新游戏。\n\n翻译自 DeepL.com（免费版）",
      "instructions": "通过拖拽相同角色重叠在一起来合并，获得更强大的角色。解锁新角色并扩充你的军队",
      "genres": [
        "休闲",
        "策略"
      ],
      "tags": [
        "1玩家",
        "军队",
        "敌人",
        "战斗",
        "单人游戏"
      ]
    },
    "zh-TW": {
      "title": "合併英雄",
      "description": "在這款遊戲中，您將指揮近戰戰士和遠程弓箭手的隊伍，與一波又一波的敵人作戰。您的靈活性和策略思維將為您帶來勝利的優勢。\n\n透過合併可購買的選項，解鎖新強大的戰士和準確的弓箭手。根據他們的能力將他們放置在地圖上，並獲得勝利。\n\n您將不僅要發現新角色，還將欣賞到美麗的各種不同世界，享受我們的新遊戲。\n\n翻譯來自 DeepL.com（免費版本）",
      "instructions": "將相同角色拖放到另一角色上合併，以獲得更強大的角色。解鎖新角色並擴展你的軍隊",
      "genres": [
        "休闲",
        "策略"
      ],
      "tags": [
        "1玩家",
        "軍隊",
        "敵人",
        "戰鬥",
        "單人遊戲"
      ]
    },
    "zh-HK": {
      "title": "合併英雄",
      "description": "在這款遊戲中，你將指揮一群近戰戰士和遠程弓箭手，與一波又一波的敵人作戰。你的靈活性和策略思考將為你帶來勝利的優勢。\n\n透過合併可購買的角色，解鎖新強大的戰士和準確的弓箭手。根據他們的能力將他們放置在地圖上，並獲得勝利。\n\n你將不僅要發現新角色，還將欣賞到美麗多樣的世界，享受我們的新遊戲。\n\n翻譯來自 DeepL.com（免費版）",
      "instructions": "將相同角色拖曳至另一角色之上以合併，獲得更強大的角色。解鎖新角色並擴充你的軍隊",
      "genres": [
        "隨意",
        "策略"
      ],
      "tags": [
        "1玩家",
        "軍隊",
        "敵人",
        "戰鬥",
        "單人遊戲"
      ]
    },
    "ja": {
      "title": "ヒーロー合体",
      "description": "このゲームでは、近接戦闘兵と遠距離射手の隊を率いて、敵の波を打ち破ります。あなたの敏捷さと戦略的な思考が勝利に導きます。\n\n購入可能なキャラクターを組み合わせることで、新しい強力な戦士や正確な射手を解封し、地図上に配置して勝利を収めましょう。\n\n新しいキャラクターだけでなく、美しい異なる世界を発見し、私たちの新しいゲームを楽しみましょう。\n\nDeepL.com（無料版）で翻訳",
      "instructions": "同じキャラクターをドラッグして重ね合わせることで強力なキャラクターを合成します。新しいキャラクターを解鎖し、軍隊を拡張します。",
      "genres": [
        "カジュアル",
        "戦略"
      ],
      "tags": [
        "1プレイヤー",
        "軍隊",
        "敵",
        "戦闘",
        "シングルプレイヤー"
      ]
    },
    "ko": {
      "title": "영웅 결합",
      "description": "이 게임에서는 근전 싸움병 부대와 거리전투 소대를 지휘하며 적의 파도를 물리치는 것이 목표입니다. 당신의敏捷성과 전략적 사고가 승리를 돕습니다.\n\n구매 가능한 것들을 결합하여 새로운 강력한 싸움병과 정확한 사냥꾼을 해금하세요. 지도에 능력에 따라 배치하고 승리하세요.\n\n새로운 캐릭터뿐만 아니라 아름다운 다양한 세계도 발견해야 합니다. 우리의 새로운 게임을 즐겨보세요.\n\nTranslated with DeepL.com (free version)",
      "instructions": "같은 캐릭터를 하나 올려다놓고 드래그하여 더 강력한 캐릭터를 얻으세요. 새로운 캐릭터를 해금하고 병력을 확장하세요.",
      "genres": [
        "캐주얼",
        "전략"
      ],
      "tags": [
        "1플레이어",
        "군대",
        "敵인",
        "전투",
        "싱글플레이어"
      ]
    },
    "fr": {
      "title": "Fusion Héros",
      "description": "Dans ce jeu, vous commanderez des escouades de combattants rapprochés et de tireurs à distance qui combattront des vagues d'ennemis. Votre agilité et votre pensée stratégique vous donneront un avantage pour la victoire.\n\nDébloquez de nouveaux combattants puissants et des tireurs à distance précis en combinant ceux disponibles à l'achat. Placez-les sur la carte en fonction de leurs capacités et gagnez.\n\nVous devrez découvrir non seulement de nouveaux personnages, mais aussi de magnifiques mondes différents, profitez de notre nouveau jeu.\n\nTraduit avec DeepL.com (version gratuite)",
      "instructions": "Fusionnez les personnages identiques en glissant un dessus l'autre pour obtenir des personnages plus puissants. Débloquez de nouveaux personnages et élargissez votre armée.",
      "genres": [
        "Casual",
        "Stratégie"
      ],
      "tags": [
        "1 joueur",
        "armée",
        "ennemis",
        "combat",
        "mode solo"
      ]
    }
  }
};
